import { ReactNode } from "react";
import { IoMdRadioButtonOn } from "react-icons/io";
import { MdOutlineRadioButtonUnchecked } from "react-icons/md";
import { clsxm } from "@/utils/clsxm";

interface IProps {
  label: ReactNode;
  value: string;
  checked: boolean;
  onClick: (value: string) => void;
  className?: string;
  disableIcon?: boolean;
}

const Radio = ({
  checked,
  value,
  label,
  onClick,
  className,
  disableIcon = false,
}: IProps) => (
  <label
    className={clsxm(
      "group flex items-center gap-4 cursor-pointer border border-new-design-gray-600/[0.08] p-4 rounded",
      "hover:border-new-design-purple-300/70 hover:bg-new-design-purple-300/[0.02]",
      checked && "border-new-design-purple-300 bg-new-design-purple-300/[0.04]",
      className
    )}
  >
    <span
      className={clsxm("text-new-design-gray-500", checked && "font-semibold")}
    >
      {label}
    </span>

    <input
      type="radio"
      value={value}
      checked={checked}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();

        onClick(value);
      }}
      onChange={() => {
        onClick(value);
      }}
      className="sr-only"
    />

    {!disableIcon && (
      <div className="h-6 min-h-6 w-6 min-w-6 ml-auto">
        {checked ? (
          <IoMdRadioButtonOn className="text-new-design-purple-300 w-full h-full" />
        ) : (
          <MdOutlineRadioButtonUnchecked className="text-slate-gray w-full h-full group-hover:text-new-design-purple-300/70" />
        )}
      </div>
    )}
  </label>
);

export { Radio };
